import { render } from "./UserDetail.vue?vue&type=template&id=79f562e4"
import script from "./UserDetail.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./UserDetail.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script